import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DashboardActivitySection from "../../component/dashboard/DashboardActivitySection";
import { handleFetchFeeds } from "../../api/fetchers";

export default function DashboardPageBottom() {
    const { business, currency } = useSelector((s) => s);
    const [feed, setFeed] = useState([]);
    const [tx, setTx] = useState([]);

    useEffect(() => {
        if (!business?._id) return;
        (async () => {
            try {
                const data = await handleFetchFeeds({ businessId: business._id, currency });
                const normalized = (data || []).map((f) => ({
                    id: f.id,
                    message: f.message,
                    metadata: f.metadata, // { category, business }
                    action: f.action, // e.g. "reminder", "view", "review"
                    type: f.type, // e.g. "invoice", "po", "shipment"
                    raw: f.data, // keep whole data for CTA handlers
                    timeISO: f.date, // used for grouping
                }));
                setFeed(normalized);
            } catch (e) {
                console.error("Failed to fetch feeds", e);
                setFeed([]); // empty state UI will show
            }
        })();
    }, [business?._id, currency]);

    return (
        <DashboardActivitySection
            className="mt-6"
            transactions={tx}
            onViewAllTransactions={() => {}}
            feed={feed}
            feedCount={feed.length}
            feedFilter="All"
            onChangeFeedFilter={(f) => console.log("filter ->", f)}
        />
    );
}
